"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9549],{

/***/ 8598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cz": function() { return /* binding */ unionByPlans; },
/* harmony export */   "FD": function() { return /* binding */ PLAN_TYPE; },
/* harmony export */   "O4": function() { return /* binding */ isIsul; },
/* harmony export */   "Uj": function() { return /* binding */ isIsulGroup; },
/* harmony export */   "VV": function() { return /* binding */ isPersonalPlan; },
/* harmony export */   "cF": function() { return /* binding */ isGroupPlan; },
/* harmony export */   "sf": function() { return /* binding */ isPlanCodeValid; }
/* harmony export */ });
const PLAN_TYPE = {
    PERSONAL: "personal",
    GROUP: "group"
};
const isPlanCodeValid = (planCode)=>typeof planCode === "string" && // not null
    planCode !== "" && // not empty string
    /[a-z]{2}(?:_[a-z]+)+_[a-z]+/i.test(planCode); // br_group_name_period
const isGroupPlan = (plan)=>plan.type === PLAN_TYPE.GROUP;
const isPersonalPlan = (plan)=>plan.type === PLAN_TYPE.PERSONAL;
const unionByPlans = (plansAndPrices)=>{
    const res = [];
    if (!Array.isArray(plansAndPrices)) {
        return res;
    }
    for(let i = 0; i < plansAndPrices.length; i += 1){
        const index = res.findIndex((item)=>{
            return (item === null || item === void 0 ? void 0 : item.newPlanCode) === plansAndPrices[i].newPlanCode;
        });
        if (index !== -1) {
            res[index].prices.push(plansAndPrices[i]);
        } else {
            res.push({
                newPlanCode: plansAndPrices[i].newPlanCode,
                newPlanName: plansAndPrices[i].newPlanName,
                minActivaions: plansAndPrices[i].subscriptionSize,
                maxActivaions: plansAndPrices[plansAndPrices.length - 1].subscriptionSize,
                prices: [
                    plansAndPrices[i]
                ]
            });
        }
    /* if (res[plansAndPrices[i].newPlanCode]) {
				res[plansAndPrices[i].newPlanCode].push(plansAndPrices[i]);
			} else {
				res[plansAndPrices[i].newPlanCode] = [plansAndPrices[i]];
			} */ }
    return res;
};
const isIsul = (planCode)=>/^.*_isul$/.test(planCode);
const isIsulGroup = (planCode)=>/^gn_group.*_isul$/.test(planCode);


/***/ }),

/***/ 34619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GO": function() { return /* binding */ isCurrentPlanPrice; },
/* harmony export */   "Im": function() { return /* binding */ PURCHASE_TYPE; },
/* harmony export */   "L2": function() { return /* binding */ isNewPlanPrice; },
/* harmony export */   "gS": function() { return /* binding */ isPurchaseFail; },
/* harmony export */   "mJ": function() { return /* binding */ PURCHASE_ERRORS; }
/* harmony export */ });
const PURCHASE_TYPE = {
    NEW: "subscription",
    SUBSCRIPTION: "subscription",
    RENEW: "renew",
    ADDON: "addon"
};
const PURCHASE_ERRORS = {
    NOT_FOUND: "errors.NOT_FOUND",
    PURCHASE_FAILED: "errors.PURCHASE_FAILED",
    UNPROCESSABLE_ENTITY: "errors.UNPROCESSABLE_ENTITY",
    SERVER_INTERNAL: "errors.SERVER_INTERNAL",
    AMOUNT_TOO_SMALL: "errors.AMOUNT_TOO_SMALL"
};
const isPurchaseFail = (error)=>{
    return (error === null || error === void 0 ? void 0 : error.type) === PURCHASE_ERRORS.PURCHASE_FAILED;
};
const isCurrentPlanPrice = (price, subscription)=>price.newPlanCode === subscription.planCode;
const isNewPlanPrice = (price, subscription)=>price.newPlanCode !== subscription.planCode;


/***/ }),

/***/ 82297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services_authService; }
});

;// CONCATENATED MODULE: ./src/services/authService/mutations/signIn.graphql
/* harmony default export */ var signIn_graphql = ("mutation signIn($email: String!, $password: String!) {\n  signIn(email: $email, password: $password) { \n    token \n    refreshToken \n    customer {\n      customerID\n    }\n  }\n}");
;// CONCATENATED MODULE: ./src/services/authService/mutations/signUp.graphql
/* harmony default export */ var signUp_graphql = ("mutation signUp(\n  $firstName: String!\n  $lastName: String!\n  $company: String!\n  $email: String!\n  $password: String!\n) {\n  signUp(signUpInput: {\n    firstName: $firstName\n    lastName: $lastName\n    company: $company\n    email: $email\n    password: $password\n    createdBy: \"customer sign up\"\n  }) {\n    token\n    refreshToken\n    customer {\n      customerID\n    }\n  }\n}\n");
;// CONCATENATED MODULE: ./src/services/authService/mutations/signOut.graphql
/* harmony default export */ var signOut_graphql = ("\tmutation signOut($refreshToken: String!) {\n\t\tsignOut(refreshToken: $refreshToken)\n\t}");
;// CONCATENATED MODULE: ./src/services/authService/mutations/forgotPassword.graphql
/* harmony default export */ var forgotPassword_graphql = ("mutation getCustomerForgotPasswordLink($email: String!) {\n  getCustomerForgotPasswordLink(email: $email)\n}\n");
;// CONCATENATED MODULE: ./src/services/authService/mutations/resetPassword.graphql
/* harmony default export */ var resetPassword_graphql = ("mutation setCustomerPasswordByPasswordResetID($passwordResetID: String!, $password: String!) {\n    setCustomerPasswordByPasswordResetID(passwordResetID: $passwordResetID, password: $password)\n}\n");
;// CONCATENATED MODULE: ./src/services/authService/mutations/exchangeToken.graphql
/* harmony default export */ var exchangeToken_graphql = ("mutation exchangeToken($issuerId: String!, $idToken: String!) {\n  exchangeToken(issuerId: $issuerId, idToken: $idToken) {\n    token\n    refreshToken\n    customer {\n      customerID\n    }\n  }\n}");
// EXTERNAL MODULE: ./src/services/authService/status.js
var authService_status = __webpack_require__(80220);
;// CONCATENATED MODULE: ./src/services/authService/index.js







const authService = (param)=>{
    let { gqlClient , storageService: { token , refreshToken , setTokens , clearAll  }  } = param;
    /** @type {(email: string, password: string) => Promise<void>} */ const signIn = (email, password)=>gqlClient(signIn_graphql, {
            email,
            password
        }).then((result)=>setTokens(result.signIn));
    /** @type {(
	    firstName: string,
	    lastName: string,
	    company: string,
	    email: string,
	    password: string,
	    turingToken: string,
	    turingType: string,
	 * ) => Promise<void>} */ const signUp = (firstName, lastName, company, email, password, turingToken, turingType)=>gqlClient(signUp_graphql, {
            firstName,
            lastName,
            email,
            password,
            company
        }, {
            headers: {
                "x-turing-token": turingToken,
                "x-turing-type": turingType
            }
        }).then((result)=>setTokens(result.signUp));
    /** @type {() => Promise<true>} */ const signOut = ()=>{
        const rToken = refreshToken.read();
        clearAll();
        if (rToken == null) return Promise.resolve(true);
        return gqlClient(signOut_graphql, {
            refreshToken: rToken
        }).then((result)=>result.signOut);
    };
    /** @type {(email: string) => Promise<boolean>} */ const forgotPassword = (email)=>gqlClient(forgotPassword_graphql, {
            email
        }).then((result)=>result.getCustomerForgotPasswordLink);
    /** @type {(passwordResetID: string, password: string) => Promise<boolean>} */ const resetPassword = (passwordResetID, password)=>{
        return gqlClient(resetPassword_graphql, {
            passwordResetID,
            password
        }).then((result)=>result.setCustomerPasswordByPasswordResetID);
    };
    const isAuthorized = ()=>(0,authService_status/* areTokensValid */.iJ)(token, refreshToken);
    /** @type {(issuerId: string, idToken: string) => Promise<void>} */ const exchangeIdToken = (issuerId, idToken)=>gqlClient(exchangeToken_graphql, {
            issuerId,
            idToken
        }).then((result)=>setTokens(result.exchangeToken));
    return {
        signIn,
        signUp,
        signOut,
        forgotPassword,
        resetPassword,
        isAuthorized,
        exchangeIdToken
    };
};
/* harmony default export */ var services_authService = (authService);


/***/ }),

/***/ 69549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services; },
  "T": function() { return /* binding */ serviceCore; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/NextPageWithServices.js
var NextPageWithServices = __webpack_require__(3200);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
// EXTERNAL MODULE: ./src/services/storage/index.js
var storage = __webpack_require__(16683);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/index.js + 3 modules
var gqlClient = __webpack_require__(82990);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/middlewares/index.js + 4 modules
var middlewares = __webpack_require__(51378);
;// CONCATENATED MODULE: ./src/services/gqlClient/index.js


var ref;
const gqlClient_gqlClient = (param)=>{
    let { storageService: { token  } , recoveryService: { shouldBeRecovered , recover  } , publicConfig: { GRAPHQL_URI  } , gqlEventsListener , apiMock , globalContext  } = param;
    return (0,gqlClient/* createGqlClient */.TV)({
        uri: GRAPHQL_URI
    }, (0,middlewares/* tap */.bw)(gqlEventsListener), (0,middlewares/* recovery */.sQ)(shouldBeRecovered, recover()), (0,middlewares/* batch */.dC)(), (0,middlewares/* context */.Do)((ctx)=>{
        var ref1;
        return {
            ...ctx,
            headers: {
                ...ctx.headers,
                Authorization: "Bearer ".concat(token.read()),
                "x-mock": apiMock.read() || undefined,
                "x-request-id": (ref = globalContext === null || globalContext === void 0 ? void 0 : (ref1 = globalContext.req) === null || ref1 === void 0 ? void 0 : ref1.requestId) !== null && ref !== void 0 ? ref : Math.random().toFixed(20).slice(2)
            }
        };
    }));
};
/* harmony default export */ var services_gqlClient = (gqlClient_gqlClient);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/operation.js + 1 modules
var gqlClient_operation = __webpack_require__(97687);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/GqlError.js
var GqlError = __webpack_require__(86870);
// EXTERNAL MODULE: ./src/domain/token.js
var token = __webpack_require__(18036);
;// CONCATENATED MODULE: ./src/services/recoveryService/refreshAccess.mutation.graphql
/* harmony default export */ var refreshAccess_mutation_graphql = ("mutation refreshAccess($refreshToken: String!) {\n  refreshAccess(refreshToken: $refreshToken) {\n    token\n    refreshToken\n  }\n}");
;// CONCATENATED MODULE: ./src/services/recoveryService/index.js




const isUnauthorized = (0,GqlError/* isExpectedGqlError */.ZO)(401);
const RecoveryService = (param)=>{
    let { storageService: { refreshToken , setTokens , clearAll  }  } = param;
    return {
        shouldBeRecovered: (err)=>isUnauthorized(err) && (0,token/* isTokenValid */.D)(refreshToken.read()),
        recover: ()=>{
            let recoveringPromise = null;
            return (context, operation, gqlClient)=>{
                recoveringPromise = recoveringPromise || gqlClient.last((0,gqlClient_operation/* Operation */.O)(refreshAccess_mutation_graphql, {
                    refreshToken: refreshToken.read()
                }), context).then((param)=>{
                    let { refreshAccess  } = param;
                    setTokens(refreshAccess);
                    recoveringPromise = null;
                }).catch((err)=>{
                    clearAll();
                    return Promise.reject(err);
                });
                return recoveringPromise;
            };
        }
    };
};
/* harmony default export */ var recoveryService = (RecoveryService);

// EXTERNAL MODULE: ./src/services/storageService/index.js
var storageService = __webpack_require__(38210);
// EXTERNAL MODULE: ./src/services/authService/index.js + 6 modules
var authService = __webpack_require__(82297);
;// CONCATENATED MODULE: ./src/services/routingService/index.js
const routingService = (param)=>{
    let { globalContext  } = param;
    return  false ? 0 : (__webpack_require__(48100)/* ["default"] */ .Z);
};
/* harmony default export */ var services_routingService = (routingService);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlEvents/index.js + 1 modules
var gqlEvents = __webpack_require__(29995);
// EXTERNAL MODULE: ./src/domain/purchase.js
var purchase = __webpack_require__(34619);
// EXTERNAL MODULE: ./src/domain/plan.js
var domain_plan = __webpack_require__(8598);
;// CONCATENATED MODULE: ./src/services/GtmGqlEvents/index.js



const gql = (0,gqlEvents/* default */.Z)();
const purchaseGtmEvent = new Map([
    [
        purchase/* PURCHASE_TYPE.SUBSCRIPTION */.Im.SUBSCRIPTION,
        "Purchased Subscription"
    ],
    [
        purchase/* PURCHASE_TYPE.RENEW */.Im.RENEW,
        "Renewed Subscription"
    ],
    [
        purchase/* PURCHASE_TYPE.ADDON */.Im.ADDON,
        "Purchased Subscription Seats"
    ]
]);
const isPersonalSubscriptionPurchase = (plan, purchaseType)=>(0,domain_plan/* isPersonalPlan */.VV)(plan) && purchaseType === purchase/* PURCHASE_TYPE.SUBSCRIPTION */.Im.SUBSCRIPTION;
const sendRegularPurchaseEvent = (orderNumber, order, purchaseType, seats, price)=>{
    var ref;
    const event = (ref = purchaseGtmEvent.get(purchaseType)) !== null && ref !== void 0 ? ref : "unknown purchase event";
    __webpack_require__.g.dataLayer = __webpack_require__.g.dataLayer || [];
    __webpack_require__.g.dataLayer.push({
        event,
        data: {
            planCode: order.subscription.plan.planCode,
            quantity: isPersonalSubscriptionPurchase(order.subscription.plan, purchaseType) ? 1 : seats,
            revenue: Math.round(price * 100),
            subscriptionId: order.subscriptionID,
            orderNumber
        }
    });
};
const sendUpgradeTrialPurchaseEvent = (orderNumber, order, seats, price)=>{
    __webpack_require__.g.dataLayer = __webpack_require__.g.dataLayer || [];
    __webpack_require__.g.dataLayer.push({
        event: "Purchased Trial",
        data: {
            planCode: order.subscription.plan.planCode,
            quantity: isPersonalSubscriptionPurchase(order.subscription.plan, purchase/* PURCHASE_TYPE.SUBSCRIPTION */.Im.SUBSCRIPTION) ? seats : seats + 1,
            revenue: Math.round(price * 100),
            subscriptionId: order.subscriptionID,
            isTrialUpgrade: 1,
            orderNumber
        }
    });
};
gql.on("purchase", (_, param, param1)=>{
    let { purchase: { orderNumber , order  }  } = param, { purchaseType , seats , newSeats , price  } = param1;
    var ref;
    return ((ref = order.subscription) === null || ref === void 0 ? void 0 : ref.isFromTrial) ? sendUpgradeTrialPurchaseEvent(orderNumber, order, newSeats, price) : sendRegularPurchaseEvent(orderNumber, order, purchaseType, seats, price);
});
const getEmailFromVars = (param)=>{
    let { email  } = param;
    return email;
};
const regAuthSuccessEvent = function(type) {
    let getEmail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getEmailFromVars;
    return (vars, result)=>{
        var ref, ref1;
        __webpack_require__.g.dataLayer = __webpack_require__.g.dataLayer || [];
        return __webpack_require__.g.dataLayer.push({
            event: "Authenticated",
            user: {
                id: ((ref = result.signIn) === null || ref === void 0 ? void 0 : ref.customer.customerID) || ((ref1 = result.signUp) === null || ref1 === void 0 ? void 0 : ref1.customer.customerID),
                email: getEmail(vars)
            },
            data: {
                authentication: {
                    type
                }
            }
        });
    };
};
const regAuthFailEvent = (type)=>(_, param)=>{
        let { originalError: { message  }  } = param;
        return __webpack_require__.g.dataLayer.push({
            event: "Returned Authentication Error",
            data: {
                authentication: {
                    type
                },
                error: {
                    msg: message
                }
            }
        });
    };
gql.on("signIn", regAuthSuccessEvent("Login"));
gql.onError("signIn", regAuthFailEvent("Login"));
gql.on("signUp", regAuthSuccessEvent("Register"));
gql.onError("signUp", regAuthFailEvent("Register"));
gql.on("cancelSubscription", (param, _, param1)=>{
    let { subscriptionId  } = param, { planCode  } = param1;
    __webpack_require__.g.dataLayer.push({
        event: "Canceled Subscription",
        data: {
            planCode,
            subscriptionId
        }
    });
});
gql.on("cancelSubscriptionWithSurvey", (param, _, param1)=>{
    let { subscriptionId  } = param, { planCode  } = param1;
    __webpack_require__.g.dataLayer.push({
        event: "Canceled Subscription",
        data: {
            planCode,
            subscriptionId
        }
    });
});
gql.on("reactivateSubscription", (param, _, param1)=>{
    let { subscriptionId  } = param, { planCode  } = param1;
    __webpack_require__.g.dataLayer.push({
        event: "Reactivated Subscription",
        data: {
            planCode,
            subscriptionId
        }
    });
});
gql.on("updatePaymentMethodV2", (param, _, param1)=>{
    let { subscriptionId  } = param, { paymentType  } = param1;
    __webpack_require__.g.dataLayer.push({
        event: "Changed Subscription Payment Method",
        data: {
            paymentMethod: paymentType,
            subscriptionId
        }
    });
});
gql.on("updateSubscriptionByID", (param, param1, param2)=>{
    let { subscriptionId , newSeats  } = param, { updateSubscriptionByID: { orderNumber , totalCharged  }  } = param1, { planCode  } = param2;
    __webpack_require__.g.dataLayer.push({
        event: "Added Subscription Seats",
        data: {
            quantity: newSeats,
            revenue: Math.round(totalCharged * 100),
            subscriptionId,
            orderNumber,
            planCode
        }
    });
});
gql.on("changeSubscriptionPlan", (param, param1)=>{
    let { subscriptionID , newPlanCode , newSubscriptionSize , planCode  } = param, { changeSubscriptionPlan: { totalCharged , orderNumber  }  } = param1;
    __webpack_require__.g.dataLayer.push({
        event: "Changed Subscription Plan",
        data: {
            subscriptionId: subscriptionID,
            currentPlanCode: planCode,
            planCode: newPlanCode,
            quantity: newSubscriptionSize,
            revenue: Math.round(totalCharged * 100),
            orderNumber
        }
    });
});
gql.on("requestTrial", (param)=>{
    let { email  } = param;
    __webpack_require__.g.dataLayer.push({
        event: "Requested Trial",
        data: {
            user: {
                email
            }
        }
    });
});
gql.on("startTrial", (param)=>{
    let { extension: { roleSelect  }  } = param;
    __webpack_require__.g.dataLayer.push({
        event: "Started Trial",
        data: {
            roleSelect
        }
    });
});
const gqlEventsListener = ()=>gql.listener;
/* harmony default export */ var GtmGqlEvents = (gqlEventsListener);

// EXTERNAL MODULE: ./src/services/subscriptionService/index.js + 2 modules
var subscriptionService = __webpack_require__(85320);
;// CONCATENATED MODULE: ./src/services/trialService/requestFreeTrial.graphql
/* harmony default export */ var requestFreeTrial_graphql = ("mutation requestTrial($email: String!) {\n    requestTrial(email: $email) {\n        ... on RequestTrialSuccess {\n            trialId\n            isAuthorized\n            token\n            refreshToken\n        }\n        ... on RequestTrialFailure {\n            errorCode\n            message\n        }\n    }\n}");
;// CONCATENATED MODULE: ./src/services/trialService/startFreeTrial.graphql
/* harmony default export */ var startFreeTrial_graphql = ("mutation startTrial($trialId: String!, $extension: JSONObject) {\n    startTrial(trialId: $trialId, extension: $extension) {\n        ... on StartTrialSuccess {\n            subscription {\n                id\n            }\n            trialStatus\n        }\n        ... on StartTrialFailure {\n            errorCode\n            message\n        }\n    }\n}");
;// CONCATENATED MODULE: ./src/services/trialService/getTrialById.graphql
/* harmony default export */ var getTrialById_graphql = ("query getTrialQuery($trialId: String!) {\n    getTrialById(trialId: $trialId) {\n        id\n    }\n}");
;// CONCATENATED MODULE: ./src/services/trialService/trialExchange.graphql
/* harmony default export */ var trialExchange_graphql = ("mutation trialExchange($requestAccessToken: String!) {\n    exchangeTrial(requestAccessToken: $requestAccessToken) {\n        ... on ExchangeTrialSuccess {\n            trialId\n            token\n            refreshToken\n        }\n        ... on ExchangeTrialFailure {\n            errorCode\n            message\n        }\n    }\n}\n");
;// CONCATENATED MODULE: ./src/services/trialService/index.js




const trialService = (param)=>{
    let { gqlClient  } = param;
    const requestFreeTrial = (email, turingToken, turingType)=>gqlClient(requestFreeTrial_graphql, {
            email
        }, {
            headers: {
                "x-turing-token": turingToken,
                "x-turing-type": turingType
            }
        });
    const startFreeTrial = (param)=>{
        let { trialId , usageSelect , roleSelect , countrySelect , labName , isIsul  } = param;
        return gqlClient(startFreeTrial_graphql, {
            trialId,
            extension: {
                groupName: labName,
                usageSelect,
                roleSelect,
                countrySelect,
                isIsul
            }
        }).then((data)=>data.startTrial);
    };
    const getTrialById = (id)=>{
        return gqlClient(getTrialById_graphql, {
            trialId: id
        }).then((data)=>data.getTrialById);
    };
    const exchangeTrial = (requestAccessToken)=>gqlClient(trialExchange_graphql, {
            requestAccessToken
        });
    return {
        startFreeTrial,
        getTrialById,
        requestFreeTrial,
        exchangeTrial
    };
};
/* harmony default export */ var services_trialService = (trialService);

// EXTERNAL MODULE: ./src/services/storageService/priceItem.js
var priceItem = __webpack_require__(77632);
// EXTERNAL MODULE: ./src/services/storageService/billingInfo.js
var billingInfo = __webpack_require__(63083);
// EXTERNAL MODULE: ./src/services/storageService/cancellationSurvey.js
var cancellationSurvey = __webpack_require__(15215);
// EXTERNAL MODULE: ./src/services/storageService/token.js
var storageService_token = __webpack_require__(66381);
// EXTERNAL MODULE: ./src/services/storageService/refreshToken.js
var refreshToken = __webpack_require__(48596);
// EXTERNAL MODULE: ./src/utils/createItemStorage.js + 1 modules
var createItemStorage = __webpack_require__(67634);
;// CONCATENATED MODULE: ./src/services/storageService/apiMock.js

const apiMock = (param)=>{
    let { storage  } = param;
    return (0,createItemStorage/* createItemStorage */.J)(storage, "x-api-mock");
};

;// CONCATENATED MODULE: ./src/services/index.js

















const serviceCore = {
    publicConfig: ()=>config/* publicConfig */.mn,
    storage: storage/* default */.Z,
    priceItem: priceItem/* priceItem */.x,
    billingInfo: billingInfo/* billingInfo */.A,
    cancellationSurvey: cancellationSurvey/* cancellationSurvey */.T,
    token: storageService_token/* token */.r,
    refreshToken: refreshToken/* refreshToken */.g,
    storageService: storageService/* default */.Z,
    recoveryService: recoveryService,
    gqlClient: services_gqlClient,
    authService: authService/* default */.Z,
    routingService: services_routingService,
    gqlEventsListener: GtmGqlEvents,
    subscriptionService: subscriptionService/* default */.Z,
    trialService: services_trialService,
    apiMock: apiMock
};
/* harmony default export */ var services = ((0,NextPageWithServices/* default */.Z)(serviceCore));


/***/ }),

/***/ 48100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

const push = next_router__WEBPACK_IMPORTED_MODULE_0___default().push.bind((next_router__WEBPACK_IMPORTED_MODULE_0___default()));
const replace = next_router__WEBPACK_IMPORTED_MODULE_0___default().replace.bind((next_router__WEBPACK_IMPORTED_MODULE_0___default()));
/* harmony default export */ __webpack_exports__["Z"] = ({
    push,
    replace
});


/***/ }),

/***/ 85320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services_subscriptionService; }
});

;// CONCATENATED MODULE: ./src/services/subscriptionService/update-subscription-billing-info.graphql
/* harmony default export */ var update_subscription_billing_info_graphql = ("mutation updateSubscriptionBillingInfo($subscriptionID: Int!, $billingInfoInput: BillingInfoUpdateInput!) {\n  updateSubscriptionBillingInfo(subscriptionID: $subscriptionID, billingInfoInput: $billingInfoInput)\n}\n");
;// CONCATENATED MODULE: ./src/services/subscriptionService/request-quote.graphql
/* harmony default export */ var request_quote_graphql = ("mutation RequestQuote($request: RequestQuoteInput!){\n  requestQuote(request: $request)\n}");
;// CONCATENATED MODULE: ./src/services/subscriptionService/index.js


const subscriptionService = (param)=>{
    let { gqlClient  } = param;
    const updateBillingInfo = (param)=>{
        let { subscriptionId: subscriptionID , billingCountryID , billingName , billingEmail , billingCompany , billingDepartment , billingAddress1 , billingAddress2 , billingCity , billingState , billingZipCode , billingPhoneNumber  } = param;
        return gqlClient(update_subscription_billing_info_graphql, {
            subscriptionID,
            billingInfoInput: {
                billingCountryID,
                billingName,
                billingEmail,
                billingCompany,
                billingDepartment,
                billingAddress1,
                billingAddress2,
                billingCity,
                billingState,
                billingZipCode,
                billingPhoneNumber
            }
        });
    };
    const requestQuote = (request)=>gqlClient(request_quote_graphql, {
            request
        });
    return {
        updateBillingInfo,
        requestQuote
    };
};
/* harmony default export */ var services_subscriptionService = (subscriptionService);


/***/ })

}]);